import axios from 'axios';

export const api = axios.create({
  baseURL: //'http://localhost:8597',
           'https://app.florestasm.com.br:8597',
  auth: {
    username: 'floresta',
    password: 'floresta!!'
  },
  //withCredentials: true
});